import React from 'react';
import './TjCenter.css';
import { Carousel, Form } from 'antd';
import { GetExhibitionBanner } from "../../api/api";
import { FormattedMessage } from 'react-intl';
import { connect } from "react-redux"
import actions from "../../store/actions"
import VlecImg from "../../component/VlecImg"



let img2 = require("../../static/images/photo-01.png");

class InnovationCenter extends React.Component {
    state = {
        GetExhibitionBanner: [],
    }

    componentWillMount() {

    }
    componentDidMount() {
        /*展厅接口*/
        GetExhibitionBanner('TJ').then((response) => {
            let data = response.DataResult;
            this.setState({
                GetExhibitionBanner: data
            });
        });
    }

    render() {
        const centertitle1 = this.props.local === 'en' ?
            "Smarter Technology for All" : "智能，为每一个可能";
        const centertitle3_1 = this.props.local === 'en' ?
            <span>Leveraging Lenovo's 3S strategy and a cutting-edge IT architecture, Lenovo (Tianjin) Future Center illustrates the company's prowess in fostering sustainable development through scientific innovation. By harnessing IoT, AI and big data, Lenovo demonstrates its capability to drive digital transformation across various sectors.</span>
            : 
            <span>联想天津未来中心位于联想（天津）智慧创新服务产业园一号楼，约6900平米，场馆共三层。诠释联想集团以科技创新响应高质量可持续发展，以全栈智能助力各行各业数字化转型升级，凸显“智能，为每一个可能”的美好愿景。</span>;
        
        const f1Title = this.props.local === 'en' ? <h4 style={{ width: "290px" }}>Lenovo Future Center,1st floor</h4> : <h4>联想未来中心1层</h4>;
        const f2Title = this.props.local === 'en' ? <h4 style={{ width: "290px" }}>Lenovo Future Center,2nd floor</h4> : <h4>联想未来中心2层</h4>;
        const f3Title = this.props.local === 'en' ? <h4 style={{ width: "290px" }}>Lenovo Future Center,3rd floor</h4> : <h4>联想未来中心3层</h4>;
        return (<div>
            {/*轮播图片*/}
            <div>
                <Carousel autoplay>
                    {this.state.GetExhibitionBanner.map((item) => {
                        return <div key={item.ID}>
                            {/* <a href={item.URL}> */}
                            <VlecImg src={item.ImagePath} alt="" />
                            {/* </a> */}

                        </div>
                    })}
                </Carousel>
            </div>
            <div className="indexDiv Innovation_Con">
                <div className="center">
                    <div className="titleH4">
                        <h4>
                            {centertitle1}
                        </h4>
                        <p className="smartP">
                            {centertitle3_1} 
                        </p>

                    </div>
                </div>
                {/*下面的图片*/}
                <div className="center centerDiv">
                    <div className="centerBock">
                        <dl>
                            <dt>
                                <img src="images/introduce01.png" alt="" />
                            </dt>
                            <dd>
                                {f1Title}
                                <p><FormattedMessage id="intl-tjcenter-f1Title2" /></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-tjcenter-f1Des" /></p>
                    </div>
                    <div className="centerBock">
                        <dl>
                            <dt>
                                <img src="images/introduce02.png" alt="" />
                            </dt>
                            <dd>
                                {f2Title}
                                <p><FormattedMessage id="intl-tjcenter-f2Title2" /></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-tjcenter-f2Des" /></p>
                    </div>
                    <div className="centerBock">
                        <dl>
                            <dt>
                                <img src="images/introduce03.png" alt="" />
                            </dt>
                            <dd>
                                {f3Title}
                                <p><FormattedMessage id="intl-tjcenter-f3Title2" /></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-tjcenter-f3Des" /></p>
                    </div>
                </div>
                <div className="imgDiv">
                    <ul className="imgBock">
                        <li>
                            <img src="images/tj/1szwmysz.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-tjcenter-1szwmyszTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-tjcenter-1szwmyszDes1"/>
                                </p>
                                <p>
                                <FormattedMessage id="intl-tjcenter-1szwmyszDes2"/>
                                </p>
                                </div>
                                
                            </div>
                        </li>
                        <li>
                        <img src="images/tj/2xit.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-tjcenter-2xitTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-tjcenter-2xitDes1"/>
                                </p>
                                </div>
                                
                            </div>
                        </li>
                        <li>
                        <img src="images/tj/3zhzf.jpg" alt="" />
                            <div className="imgHover">
                                <h4> <FormattedMessage id="intl-tjcenter-3zhzfTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-tjcenter-3zhzfDes1"/>
                                </p> 
                                </div> 
                            </div>
                        </li>
                        <li>
                        <img src="images/tj/4zhyl.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-tjcenter-4zhylTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-tjcenter-4zhylDes1"/>
                                </p>
                                </div>
                            </div>
                        </li>
                        <li>
                        <img src="images/tj/5zhjy.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-tjcenter-5zhjyTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-tjcenter-5zhjyDes1"/>
                                </p> 
                                </div> 
                            </div>
                        </li>
                        <li>
                        <img src="images/tj/6zhgjn.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-tjcenter-6zhgjnTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-tjcenter-6zhgjnDes1"/>
                                </p> 
                                </div> 
                            </div>
                        </li>
                        <li>
                        <img src="images/tj/7zhjr.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-tjcenter-7zhjrTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-tjcenter-7zhjrDes1"/>
                                </p> 
                                </div> 
                            </div>
                        </li>
                        <li>
                        <img src="images/tj/8znzz.jpg" alt="" />
                            <div className="imgHover">
                                <h4>  <FormattedMessage id="intl-tjcenter-8znzzTitle"/></h4>
                                <div className="imgFone">
                                <p>  <FormattedMessage id="intl-tjcenter-8znzzDes1"/></p> 
                                </div> 
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>)
    }
};
export default connect(state => ({ ...state.Language }), actions.Language)(InnovationCenter)


// WEBPACK FOOTER //
// ./src/containers/TjCenter/TjCenter.js